var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83301 9.16675H20.1663",
    stroke: "#0033CC",
    strokeWidth: 1.375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5876 18.7922H5.90339C2.64923 18.7922 1.82422 17.9855 1.82422 14.768V7.23296C1.82422 4.31796 2.50258 3.38296 5.06008 3.23629C5.31675 3.22712 5.60089 3.21796 5.90339 3.21796H16.0876C19.3417 3.21796 20.1667 4.02462 20.1667 7.24212V11.2847",
    stroke: "#0033CC",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 14.6667H9.16667",
    stroke: "#0033CC",
    strokeWidth: 1.375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1663 16.5C20.1663 17.1875 19.9738 17.8384 19.6347 18.3884C19.0022 19.4517 17.838 20.1667 16.4997 20.1667C15.1613 20.1667 13.9972 19.4517 13.3647 18.3884C13.0255 17.8384 12.833 17.1875 12.833 16.5C12.833 14.4742 14.4738 12.8334 16.4997 12.8334C18.5255 12.8334 20.1663 14.4742 20.1663 16.5Z",
    stroke: "#0033CC",
    strokeWidth: 1.375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0713 16.4992L15.9788 17.4067L17.9313 15.6009",
    stroke: "#0033CC",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.633a631bc3e6ac3c6edbea4f973338fb.svg";
export { ForwardRef as ReactComponent };